module.exports = __webpack_public_path__ + "static/media/silestone.bcc96f68.svg";